import React from 'react';
import { renderInputField } from './shared';
import { BaseInputProps } from './types';

export const ShortTextInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  textInputPlaceholder,
}) =>
  renderInputField({
    value: answers[currentQuestion.id]?.shortText || '',
    onChange: (e) =>
      dispatch({
        type: 'SET_SHORT_TEXT',
        questionId: currentQuestion.id,
        payload: e.target.value,
      }),
    placeholder: textInputPlaceholder,
    testId: 'form-preview-short-text-input',
  });
